import { Component, input } from '@angular/core';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';

import { Route, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'dges-drop-down-menu',
  templateUrl: './drop-down-menu.component.html',
  standalone: true,
  imports: [
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatIconButton,
    RouterLink,
    MatIcon,
  ],
})
export class DropDownMenuComponent {
  readonly fillerNav = input<Route[]>([]);
}
